import { Button } from '@uswitch/spark'
import { Us2Rocket, Us2Filter, Us2Close, Us2Plug, Us2Speedtest, Us2Piggybank } from '@uswitch/spark-icons/us2'
import { useState, useEffect } from 'react'

import { CITY_FIBRE_OUTCODES_MK, isProviderOutcode } from '../pages/hull/utils/postcode'
import smoothScrollTo from '~/utils/smooth-scroll-to'
import { track, trackSegment } from '~/utils/tracking'

import styles from './city-fibre.module.css'

const URLS = {
  'milton-keynes': {
    poster:
      'https://img.uswitch.com/g836doytpz4a/5z6WknDZdj6VijW9VQDoRQ/f7efe47baa451a76ba7d571e3841609b/Desktop-MK-Banner.png?q=45&auto=format,compress',
    video:
      'https://img.uswitch.com/g836doytpz4a/1lc0h6AmajkTuJMh7Crjh4/9f0938e662dbc7629f7f611eb7cd927b/MK-loop-banner-compressed__1_.mp4'
  },
  coventry: {
    poster:
      'https://img.uswitch.com/g836doytpz4a/VJB5T12s1bGYoGldM6z8N/e6820d82d9ad478918f41ef019f1eb5a/Desktop-CV-Banner.png?q=45&auto=format,compress',
    video:
      'https://img.uswitch.com/g836doytpz4a/3ThKdMU8qLAOvRi16fuz2s/f86e128d21e74f5827363a4e1d4a0df6/CV-loop-banner-compressed__1_.mp4'
  }
}

const CityFibreBanner = ({
  isIntersecting,
  setIsIntersecting,
  postcode,
  setFilter,
  distanceToTable,
  tableTopOffset,
  showBannerButton,
  setShowBannerButton
}) => {
  const [isPlaying, setPlaying] = useState(false)

  const onPlay = () => {
    setPlaying(true)
  }

  useEffect(() => {
    track('Broadband - City Fibre Next Gen banner', 'City Fibre Next Gen banner shown')

    trackSegment('Element Viewed', {
      element_name: 'City Fibre Next Gen banner',
      element_type: 'banner',
      org_brand: 'uswitch'
    })
  })

  const urls = isProviderOutcode(postcode, CITY_FIBRE_OUTCODES_MK) ? URLS['milton-keynes'] : URLS.coventry

  return (
    <>
      <div className={`${styles.filterBanner} ${isIntersecting ? '' : styles.filterBanner__mobile}`}>
        <video
          muted
          autoPlay
          loop
          poster={urls.poster}
          className={`${isIntersecting ? '' : styles.hidden} ${isPlaying ? styles.fadeIn : ''}`}
          onPlay={onPlay}
        >
          <source
            src={urls.video}
            type='video/mp4'
            media='(min-width: 999px) and (prefers-reduced-motion: no-preference)'
          />
        </video>
        <div className={styles.content}>
          <div className={styles.filterBanner__postcode__container}>
            <div className={styles.filterBanner__badge}>
              <Us2Rocket size={'24px'} color={'#141414'} />{' '}
              <p className={styles.filterBanner__badge__text}>Next gen full fibre</p>
            </div>
            <p className={styles.filterBanner__postcode}> now in {postcode}</p>
          </div>
          <Us2Close
            size='32'
            className={`${styles.filterBanner__closeButton} ${isIntersecting ? styles.hidden : styles.visibleMobile}`}
            onClick={() => {
              setIsIntersecting(true)
            }}
          />

          <div className={`${isIntersecting ? styles.visibleMobile : styles.hiddenMobile}`}>
            <h5 className={styles.filterBanner__headline}>You can get speeds 27x faster than the UK average</h5>
            <div className={styles.filterBanner__attributes}>
              <div className={styles.filterBanner__attribute}>
                <span className={styles.filterBanner__icon}>
                  <Us2Plug size={'100%'} />
                </span>
                <p className={styles.filterBanner__attribute__text}>
                  Built with the UK’s most reliable broadband technology
                </p>
              </div>
              <div className={styles.filterBanner__attribute}>
                <span className={styles.filterBanner__icon}>
                  <Us2Speedtest size={'100%'} />
                </span>
                <p className={styles.filterBanner__attribute__text}>
                  Stream, game and work lag-free with faster uploads
                </p>
              </div>
              <div className={styles.filterBanner__attribute}>
                <span className={styles.filterBanner__icon}>
                  <Us2Piggybank size={'100%'} />
                </span>
                <p className={styles.filterBanner__attribute__text}>
                  Plus, you could save £179 when you switch<sup>**</sup>
                </p>
              </div>
            </div>
          </div>

          {showBannerButton && (
            <Button
              className={styles.filterBanner__button}
              size='large'
              rightIcon={<Us2Filter size='24' />}
              variant='tertiary'
              onClick={() => {
                trackSegment('Element Clicked', {
                  element_name: 'Filter Button',
                  element_text: 'View deals',
                  element_type: 'button'
                })
                track('Broadband - CityFibre Banner', 'Filter selected')
                setFilter({ nextGenTrial: ['CITY_FIBRE_TRIAL'] })
                setShowBannerButton(false)
                setIsIntersecting(true)
                smoothScrollTo('#table-header', distanceToTable, tableTopOffset)
              }}
            >
              View deals
            </Button>
          )}
        </div>
      </div>
    </>
  )
}

export default CityFibreBanner
